const timeFormatter = new Intl.DateTimeFormat(undefined, {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

/** Formats a message timestamp in the user's local timezone (24h `HH:mm`). */
export function formatMessageTime(date: string | Date): string {
  const value = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(value.getTime())) {
    return '';
  }
  return timeFormatter.format(value);
}
